import { render, staticRenderFns } from "./Cuentas_editar.vue?vue&type=template&id=00b89138&scoped=true"
import script from "./Cuentas_editar.vue?vue&type=script&lang=js"
export * from "./Cuentas_editar.vue?vue&type=script&lang=js"
import style0 from "./Cuentas_editar.vue?vue&type=style&index=0&id=00b89138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b89138",
  null
  
)

export default component.exports